<button
    type="button"
    class="fixed left-1/2 top-3 max-w-[calc(100vw-2rem)] -translate-x-1/2 -translate-y-[150%] whitespace-nowrap opacity-0 focus-visible:translate-y-0 focus-visible:opacity-100 transition-all duration-300 z-[1000] bg-[var(--actionColor)] text-[#00183b] px-3 rounded border-2 border-transparent focus-visible:border-[#00183b]"
    (click)="onSkipLinkClick($event)"
    [attr.aria-label]="label()"
    [disabled]="disabled()"
>
    <sh-icon icon="arrow-line-right-s" size="s" class="pr-1"></sh-icon>
    <span>{{ label() }}</span>
</button>
